webpackJsonp([9,17,18,19],{

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var AddHomeBannerStyle = function AddHomeBannerStyle() {
  var itens = document.getElementsByClassName('main-slider-item__banner');
  Object.keys(itens).forEach(function (key) {
    var element = itens[key];
    element.style.backgroundImage = 'url("' + element.dataset.banner + '")';
  });
};

/* harmony default export */ __webpack_exports__["default"] = (AddHomeBannerStyle);

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var tabsFn = function tabsFn() {
  var select = $('.services__select select');
  var nav = $('.services__nav');
  var tabs = $('.services-tabs');

  nav.on('click', 'a', function () {
    var rel = $(this).attr('rel');

    nav.find('a').removeClass('active');
    $(this).addClass('active');

    tabs.find('.fade').removeClass('active in');
    tabs.find('[rel="' + rel + '"]').addClass('active in');

    select.val(rel);
  });

  select.on('change', function () {
    var current = $(this).val();

    nav.find('a').removeClass('active');
    nav.find('[rel="' + current + '"]').trigger('click');
  });
};

/* harmony default export */ __webpack_exports__["default"] = (tabsFn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper__ = __webpack_require__(1);


var newsSlide = void 0;
// eslint-disable-next-line no-unused-vars
var newsBooks = void 0;
var newsService = void 0;
// eslint-disable-next-line no-unused-vars
var newsMain = void 0;
// eslint-disable-next-line no-unused-vars
var testimonialService = void 0;
// eslint-disable-next-line no-unused-vars
var interactiveService = void 0;
// eslint-disable-next-line no-unused-vars
var featuredArticleService = void 0;
var breakpoint = window.matchMedia('(max-width: 767px)');

var carouselProperties = {
  release: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.release__list--buttons .swiper-button-next',
      prevEl: '.release__list--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.release__list--bullets .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      545: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  newsHomeSlide: {
    watchOverflow: true,
    spaceBetween: 10,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.newsHomeSlide--buttons .swiper-button-next',
      prevEl: '.newsHomeSlide--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.newsSlide--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      501: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  newsHomeSlide2: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.newsHomeSlide--buttons .swiper-button-next',
      prevEl: '.newsHomeSlide--buttons .swiper-button-prev'
    },
    pagination: {
      el: '.newsSlide--bullets2',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      501: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  mainServiceSlide: {
    watchOverflow: true,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--main',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  testimonialSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--testimonial',
      type: 'bullets',
      clickable: true
    }
  },
  interactiveSlide: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--interactive',
      type: 'bullets',
      clickable: true
    }
  },
  serviceSlide: {
    animateOut: 'fadeOut',
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    margin: 0,
    autoHeight: true,
    mouseDrag: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--testimonial',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  testimonial: {
    animateOut: 'fadeOut',
    items: 1,
    loop: true,
    margin: 0,
    autoHeight: true,
    dots: true,
    nav: false,
    mouseDrag: false,
    dotsContainer: '.interactive-testimonial__control'
  },
  propertyGallery: {
    animateOut: 'fadeOutLeft',
    animateIn: 'fadeInRight',
    items: 1,
    loop: true,
    margin: 0,
    dots: true,
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    dotsContainer: '#main-slider-dots__list'
  },
  propertyMain: {
    loop: true,
    margin: 12,
    dots: true,
    mouseDrag: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 3
      },
      768: {
        items: 6
      }
    }
  },
  booksSliders: {
    watchOverflow: true,
    spaceBetween: 20,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination--news-books',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      550: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      767: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      1023: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    }
  }
};

var newsHomeSlide = function newsHomeSlide() {
  newsSlide = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--news-home-slider', carouselProperties.newsHomeSlide);
};
var mainServiceSlide = function mainServiceSlide() {
  newsMain = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--main', carouselProperties.mainServiceSlide);
};
var serviceSlide = function serviceSlide() {
  newsService = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--service', carouselProperties.serviceSlide);
};
var testimonialSlide = function testimonialSlide() {
  testimonialService = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--testimonial', carouselProperties.testimonialSlide);
};
var interactiveSlide = function interactiveSlide() {
  interactiveService = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--interactive', carouselProperties.interactiveSlide);
};
var booksCarousel = function booksCarousel() {
  newsBooks = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--news-books', carouselProperties.booksSliders);
};
var featuredArticleCarousel = function featuredArticleCarousel() {
  featuredArticleService = new __WEBPACK_IMPORTED_MODULE_0_swiper__["a" /* default */]('.swiper-container--feature-articles', carouselProperties.newsHomeSlide2);
};

var breakpointChecker = function breakpointChecker() {
  mainServiceSlide();
  testimonialSlide();
  newsHomeSlide();
  booksCarousel();
  serviceSlide();
  if (breakpoint.matches === false) {
    $('.swiper-container--news-home-slider .news-item__description').removeClass('news-item__description--mobile');
    $('.swiper-container--news-home-slider .news-item__title').removeClass('news-item__title--mobile');
    $('.swiper-container--feature-articles .news-item__description').removeClass('news-item__description--mobile');
    $('.swiper-container--feature-articles .news-item__title').removeClass('news-item__title--mobile');

    if (newsSlide !== undefined) {
      // console.log(newsMain);
      newsSlide.destroy(true, true);
      $('.newsSlide--bullets').html('');
      $('.swiper-pagination--service').html('');

      $(newsService).each(function (index) {
        if (newsService[index] && newsService[index].destroy) {
          newsService[index].destroy(true, true);
        }
      });

      return;
    }
  }if (breakpoint.matches === true) {
    featuredArticleCarousel();
    interactiveSlide();
    $('.swiper-container--news-home-slider .news-item__description').addClass('news-item__description--mobile');
    $('.swiper-container--news-home-slider .news-item__title').addClass('news-item__title--mobile');
    $('.swiper-container--feature-articles .news-item__description').addClass('news-item__description--mobile');
    $('.swiper-container--feature-articles .news-item__title').addClass('news-item__title--mobile');
  }
};

breakpoint.addListener(breakpointChecker);

/* harmony default export */ __webpack_exports__["default"] = (breakpointChecker);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homeBannerImages__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serviceTabs__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__homeCarousel__ = __webpack_require__(44);




document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__homeBannerImages__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_1__serviceTabs__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_2__homeCarousel__["default"])();
});

/***/ })

},[58]);


// WEBPACK FOOTER //
// home/home-e087da4c1866a851cac7.js